import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { CreditLabel } from '~/components/layout/CreditLabel';

export const InsufficientCreditsNotice = ({
  locale,
  available,
  required,
}: {
  locale?: string;
  available?: string;
  required: string;
}): ReactElement => {
  const { t } = useTranslation('billing');
  const resolvedLocale = locale ?? 'en';

  if (available === undefined) {
    return (
      <p className="flex flex-wrap items-center gap-x-1 gap-y-1 text-muted">
        <span>{t('requiredCreditsOnlyPrefix')}</span>
        <CreditLabel
          balance={required}
          locale={resolvedLocale}
          variant="inline"
        />
        <span>{t('requiredCreditsOnlySuffix')}</span>
      </p>
    );
  }

  const shortage = String(Math.max(0, Number(required) - Number(available)));

  return (
    <p className="flex flex-wrap items-center gap-x-1 gap-y-1 text-muted">
      <span>{t('insufficientCreditsNeed')}</span>
      <CreditLabel
        balance={required}
        locale={resolvedLocale}
        variant="inline"
      />
      <span>{t('insufficientCreditsHave')}</span>
      <CreditLabel
        balance={available}
        locale={resolvedLocale}
        variant="inline"
      />
      <span>{t('insufficientCreditsNeedMore')}</span>
      <CreditLabel
        balance={shortage}
        locale={resolvedLocale}
        variant="inline"
      />
      <span>{t('insufficientCreditsMoreSuffix')}</span>
    </p>
  );
};
